import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { AccessService } from '../../services/access/access.service';
import { UserService } from '../../services/user/user.service';
import { User } from '../../shared/models/user.model';

export const authenticationGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userService = inject(UserService);
  const accessService = inject(AccessService);

  if (accessService.userInfo()) {
    return of(true);
  }

  return userService.getUserDetails().pipe(
    map((user: User) => {
      accessService.userInfo = user;
      return true;
    }),
    catchError((_) => {
      accessService.logout(false);
      return of(router.createUrlTree(['/login']));
    })
  );
};
